const subscribers = {};
const buffers = {};
const bufferSize = {};

function subscribe(eventName, callback, replayCount = 1) {
  if (!subscribers[eventName]) {
    subscribers[eventName] = [];

  }

  if (!bufferSize[eventName]) {
    bufferSize[eventName] = replayCount;
  }

  if (buffers[eventName]) {
    for (const value of buffers[eventName]) {
      callback(value);
    }
  }

  subscribers[eventName].push(callback);

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
}

function publish(eventName, data) {
  if (!buffers[eventName]) {
    buffers[eventName] = [];
  }

  buffers[eventName].push(data);

  if (bufferSize[eventName] && buffers[eventName].length > bufferSize[eventName]) {
    buffers[eventName].shift();
  }

  if (subscribers[eventName]) {
    for (const callback of subscribers[eventName]) {
      callback(data);
    }
  }
}
